// extracted by mini-css-extract-plugin
export default {"descritonText":"iOANO7200-G4kn9BoVsH3Q=="};